module.exports = __webpack_public_path__ + "static/wordmark.37d11ee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wordmark.png
// module id = 455
// module chunks = 35783957827783